import { useGetCourseCompletionQuizResult } from "@/api/generated/course-completion-quiz/course-completion-quiz";
import { hasFinishedRun } from "@/lib/courseCompletionQuiz";
import type {
  CompletionQuizResult,
  CourseCompletionQuizStatus,
} from "@/types/courseCompletionQuiz";

interface CourseCompletionQuizDetails {
  lastResult: CompletionQuizResult | null;
}

/**
 * Loads the last finished run for the dashboard card. Only a status that
 * looks back at a result asks for it.
 */
const useCourseCompletionQuizDetails = (
  enrollmentId: string | undefined,
  status: CourseCompletionQuizStatus | undefined
): CourseCompletionQuizDetails => {
  const looksBackAtResult =
    enrollmentId !== undefined &&
    status !== undefined &&
    hasFinishedRun(status);

  const { data: lastResult } = useGetCourseCompletionQuizResult(
    enrollmentId ?? "",
    { swr: { enabled: looksBackAtResult } }
  );

  return {
    lastResult: lastResult ?? null,
  };
};

export { useCourseCompletionQuizDetails };
